module.exports = __webpack_public_path__ + "static/media/ansible.48d29d3c.png";